<template>
  <div class="card" :class="{ 'is-blurred': startup.is_obfuscated }">
    <div class="card-img">
      <a :href="startupProfileLink(startup)" target="_newProfile">
        <img
          class="card-img-top"
          :src="startup.logo_url | cld({ h: 90, c: 'limit' })"
          alt=""
        />
        <img
          class="card-img-hover"
          :src="startup.logo_url | cld({ w: 350, h: 350, c: 'limit' })"
          alt=""
        />
      </a>
    </div>
    <div class="card-block">
      <h4 class="card-title text-center">
        <a :href="startupProfileLink(startup)" target="_newProfile">
          {{ startup.name }}
        </a>
      </h4>

      <p class="card-text">
        {{ startup.caption }}
      </p>
    </div>
    <ul class="list-group clearfix">
      <li class="list-group-item">
        Current round
        <span v-show="startup.round_size" class="pull-right"
          >{{ startup.round_size | roundedNumber }} €</span
        >
        <span v-show="!startup.round_size" class="pull-right">-</span>
      </li>
      <li class="list-group-item hidden">
        Revenue <span class="pull-right">€20.000</span>
      </li>

      <li class="list-group-item hidden">
        Monthly revenue
        <span v-show="startup.previous_rounds" class="pull-right"
          >{{ startup.previous_rounds | roundedNumber }} €</span
        >
        <span v-show="!startup.previous_rounds" class="pull-right">-</span>
      </li>
    </ul>
    <div class="card-block clearfix">
      <ul class="list-group">
        <li class="list-group-item">
          <span class="icon icon-map" />
          {{ startup.city
          }}<span v-show="startup.city && startup.country">, </span
          >{{ startup.country | countryName }}
        </li>
        <li class="list-group-item sectors">
          <span class="icon icon-bulb" />
          <span v-for="sector in startup.sectors" :key="sector">
            {{ sector | sectorLabel }}
          </span>
          <span v-show="!startup.sectors">-</span>
        </li>
      </ul>
    </div>
    <div class="card-actions clearfix">
      <span v-if="user.isAdmin" class="center">
        <el-tooltip
          :content="startup.has_promode ? 'Demote' : 'Promote'"
          placement="top"
        >
          <button
            class="btn btn-xs"
            :class="{
              'btn-success': startup.has_promode,
              'btn-danger': !startup.has_promode,
            }"
            @click.prevent="toggleProStatus(startup)"
          >
            <i v-if="startup.has_promode" class="ion ion-checkmark" />
            <i v-if="!startup.has_promode" class="ion ion-close" />
          </button>
        </el-tooltip>
      </span>
      <span v-if="user.isInvestorOrOrganizer">
        <el-dropdown
          v-if="user.role !== 'STARTUP'"
          class="rate-button-group"
          split-button
          type="primary"
          size="mini"
          :show-timeout="0"
          @click="openRateDialog({ startup })"
          @command="openRateDialog({ startup })"
        >
          <template v-if="startupsRatingValue[startup.id]">
            Rated {{ startupsRatingValue[startup.id]
            }}<i class="ion ion-star"></i>
          </template>
          <template v-else>Rate</template>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="rate">Change rating</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </span>
      <ConnectWithStartup
        v-if="user.isInvestorOrOrganizer"
        :disabled="startup.is_obfuscated"
        :startup="startup"
        :org-id="user.organizationId"
      />

      <br />
      <ShortlistStartup
        v-if="user.isInvestorOrOrganizer"
        :startup="startup"
        :org-id="user.organizationId"
        @update="
          ({ shortlists }) => onStartupShortlistUpdate({ shortlists, startup })
        "
      />

      <el-tooltip v-if="user.isAdmin" content="Edit" placement="top">
        <router-link
          class="edit-wrapper btn btn-primary btn-xs"
          :to="{ name: 'adminStartupEdit', params: { id: startup.id } }"
        >
          <i class="ion ion-edit" />
        </router-link>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { features } from 'utils/features'
import { sectorLabel } from '@/services/sectors'
import { roundedNumber } from '@/filters'
import { countryName } from '@/services/countries'
import ConnectWithStartup from 'components/organizations/ConnectWithStartup'
import ShortlistStartup from 'components/organizations/ShortlistStartup/ShortlistStartup.vue'

export default {
  components: { ConnectWithStartup, ShortlistStartup },
  filters: { sectorLabel, roundedNumber, countryName },
  props: {
    startup: { type: Object, required: true },
    startupsRatingValue: { type: Object, required: true, default: () => ({}) },
    openRateDialog: { type: Function, required: true },
    onInterestChanged: { type: Function, required: true },
    promoteStartup: { type: Function, required: true },
    demoteStartup: { type: Function, required: true },
    toggleProStatus: { type: Function, required: true },
    startFollowing: { type: Function, required: true },
    stopFollowing: { type: Function, required: true },
    shortlistId: { type: String, default: null },
  },
  data: () => ({
    features,
  }),
  computed: {
    ...mapState({
      user: (state) => state.user.data,
    }),
  },
  methods: {
    startupProfileLink(startup) {
      return this.$router.resolve({
        name: 'publicStartupProfile',
        params: { slug: startup.slug || startup.id },
      }).href
    },
    onStartupShortlistUpdate({ startup, shortlists }) {
      if (this.shortlistId) {
        // we are at the specific shortlist page
        // if it's not within updated shortlsits then this startup should be removed
        if (!shortlists.map((s) => s.id).includes(this.shortlistId)) {
          this.$store.dispatch('startupList/removeStartup', {
            id: startup.id,
          })
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
.card-actions {
  border-top: 1px solid #f4f4f4;
  padding: 14px 0 14px;
  justify-content: space-evenly;
  display: flex;
}
</style>
